var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatAssistantWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.647,
    height: 23.652,
    viewBox: "0 0 23.647 23.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2219",
    "data-name": "Raggruppa 2219",
    transform: "translate(-13213.645 21609.65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3523",
    "data-name": "Tracciato 3523",
    d: "M26.078,16.031h-.17a6.987,6.987,0,0,0-6.8-5.457H16.983V9.8a2.729,2.729,0,1,0-1.819,0v.776H13.042a6.987,6.987,0,0,0-6.8,5.457h-.17A1.824,1.824,0,0,0,4.25,17.85v1.819a1.824,1.824,0,0,0,1.819,1.819H6.4a7.006,7.006,0,0,0,4.79,4.6,2.693,2.693,0,0,0-.273,1.164.908.908,0,0,0,.909.91h8.489a.908.908,0,0,0,.91-.91,2.673,2.673,0,0,0-.273-1.164,6.994,6.994,0,0,0,4.79-4.6h.333A1.824,1.824,0,0,0,27.9,19.669V17.85A1.824,1.824,0,0,0,26.078,16.031Zm-10-9.7a.909.909,0,1,1-.91.909A.908.908,0,0,1,16.073,6.33Zm3.032,18.19H13.042a5.157,5.157,0,0,1-5.154-5.154V17.547a5.157,5.157,0,0,1,5.154-5.154h6.063a5.157,5.157,0,0,1,5.154,5.154v1.819A5.157,5.157,0,0,1,19.105,24.52Z",
    transform: "translate(13209.395 -21614.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3524",
    "data-name": "Tracciato 3524",
    d: "M16.033,19.909a1.824,1.824,0,0,0-1.819,1.819v1.819a1.819,1.819,0,1,0,3.638,0V21.728A1.824,1.824,0,0,0,16.033,19.909Z",
    transform: "translate(13206.101 -21619.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3534",
    "data-name": "Tracciato 3534",
    d: "M26,19.909a1.824,1.824,0,0,0-1.819,1.819v1.819a1.819,1.819,0,0,0,3.638,0V21.728A1.824,1.824,0,0,0,26,19.909Z",
    transform: "translate(13202.807 -21619.248)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3525",
    "data-name": "Tracciato 3525",
    d: "M12.118,6.279l1.819.606a.97.97,0,0,0,.285.049.912.912,0,0,0,.285-1.777l-1.819-.606a.914.914,0,0,0-1.152.576.9.9,0,0,0,.576,1.152Z",
    transform: "translate(13207.002 -21614.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3526",
    "data-name": "Tracciato 3526",
    d: "M12.4,11.463a.763.763,0,0,0,.285-.048l1.819-.606a.911.911,0,0,0-.576-1.728l-1.819.606a.912.912,0,0,0,.285,1.777Z",
    transform: "translate(13207.001 -21615.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3535",
    "data-name": "Tracciato 3535",
    d: "M27.8,6.934a.762.762,0,0,0,.285-.049l1.819-.606a.911.911,0,0,0-.576-1.728l-1.819.606A.912.912,0,0,0,27.8,6.934Z",
    transform: "translate(13201.91 -21614.154)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3536",
    "data-name": "Tracciato 3536",
    d: "M27.517,10.808l1.819.606a.969.969,0,0,0,.285.048.912.912,0,0,0,.285-1.777L28.087,9.08a.911.911,0,0,0-.576,1.728Z",
    transform: "translate(13201.91 -21615.652)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatAssistantWhite);
export default __webpack_public_path__ + "static/media/chat-assistant-white.c7417d119507eae17b633e0fea39f59a.svg";
export { ForwardRef as ReactComponent };